import { useMemo, useState } from 'react';
import type { RegisterOptions } from 'react-hook-form';

type TUseComposeResponseValidationRules = {
    validationMessages: Record<string, string | null>;
};

export const useComposeResponseValidationRules = ({ validationMessages }: TUseComposeResponseValidationRules) => {
    const [formValues, setFormValues] = useState<Record<string, string | null>>({});

    const validationRules = useMemo<Record<string, Pick<RegisterOptions<Record<string, string>>, 'validate'>>>(
        () =>
            Object.keys(validationMessages).reduce(
                (acc, fieldName) => ({
                    ...acc,
                    [fieldName]: {
                        validate: (value?: string) => {
                            if (validationMessages[fieldName] && formValues[fieldName] === value) {
                                return validationMessages[fieldName];
                            }

                            return true;
                        },
                    },
                }),
                {},
            ),
        [validationMessages, formValues],
    );

    return useMemo(() => ({ validationRules, updateInput: setFormValues }), [validationRules]);
};
